import { render, staticRenderFns } from "./patch-score-board.vue?vue&type=template&id=255e112e&scoped=true"
import script from "./patch-score-board.vue?vue&type=script&lang=js"
export * from "./patch-score-board.vue?vue&type=script&lang=js"
import style0 from "./patch-score-board.vue?vue&type=style&index=0&id=255e112e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255e112e",
  null
  
)

export default component.exports